import request from '@/utils/request'


//查询首页--轮播图/合作伙伴 type=1 轮播表 2合作伙伴表
export function getCarouselList(query) {
  return request({
    url: '/api/carousel/list',
    method: 'get',
    params: query
  })
}
//查询首页--产品
export function homeProductList(query) {
  return request({
    url: '/api/product/getProductList',
    method: 'get',
    params: query
  })
}
export function getNewsList(query) {
  return request({
    url: '/api/websiteArticle/getHomeNewsList',
    method: 'get',
    params: query
  })
}

// 手机端首页新闻
export function getHomeMobileNewsLis (query) {
  return request({
    url: '/api/websiteArticle/getHomeMobileNewsList',
    method: 'get',
    params: query
  })
}
export function getVideoList(query) {
  return request({
    url: '/api/websiteArticle/getVideoList',
    method: 'get',
    params: query
  })
}

export function getBrandHonors(query) {
  return request({
    url: '/api/aboutUs/brandHonors',
    method: 'get',
    params: query
  })
}

export function getAcademicList(query) {
  return request({
    url: '/api/websiteArticle/getacademicList',
    method: 'get',
    params: query
  })
}


export function sitemap() {
  return request({
    url: '/api/sitemap',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/home.js